export const EVENT_COLUMNS = [
    {
        header: "Группа",
        field: "event_group_index",
        dataType: "image",
        image: [51, 54, 51, 53, 52],
        sortable: true,
        bodyStyle: "text-align: center;",
    },
    {
        header: "Объект",
        field: "facility_name",
        sortable: true,
        filterData: {
            options: 'facility',
            type: "MultiSelect",
            attrList: { filter: true, appendTo: "body", },
            mode: "in",
            "max-width": "80px",
        },
    },
    {
        header: "Фл",
        field: "flange_no",
        bodyStyle: "text-align: right;",
        sortable: true,
    },
    {
        header: "Событие",
        field: "event_type_name",
        sortable: true,
    },
    {
        header: "Свойство",
        field: "property_type_name",
        sortable: true,
    },
    {
        header: "Дата события",
        dataType: "date-time-gmt",
        conversion: true,
        headerStyle: "width: 140px",
        field: "event_date",
        sortable: true,
    },
    {
        header: "K",
        field: "event_confirm",
        dataType: "check-box",
        headerStyle: "width: 1rem",
        bodyStyle: "text-align: center;overflow: visible",
        configComponent: {
            name: "i",
            iconTrue: "pi pi-pencil",
            iconFalse: "pi pi-trash",
            classTrue: "pi true-icon pi-check-circle",
            classFalse: "pi false-icon pi-times-circle",
            componentFunction: () => { },
        },
    },
    {
        header: "Категория",
        field: "event_category_name",
        sortable: true,
    },
    {
        header: "Знач",
        field: "property_value",
        bodyStyle: "text-align: right;",
        sortable: true,
    },
];
export const DICTIONARY = [
    {
        options: "result",
        save: { store: false, self: true },
        load: "parent",
        data() {
            return [
                { ["name"]: "Ошибка", id: 0 },
                { ["name"]: "Успешно", id: 1 },
            ];
        },
    },
];
export const DICTIONARY_EVENT = [
    {
        options: "facility",
        save: { store: false, self: true },
        load: "store",
    },
];
export const TOOLBAR_FILTERS = [
    {
        name: "periods",
        enabled: true,
        required: true,
        attrList: { showTime: true, date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
        default: "Текущий день",
    },
];